module.exports = __webpack_public_path__ + "static/media/paypal-logo.400e7bc9.svg";